"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessTableModalContentTabContent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const PageLoaderComponent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/common/pageLoader/PageLoaderComponent"));
const antd_1 = require("antd");
const retention_table_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/table/retention_table");
const RetentionTableService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/table/RetentionTableService");
const StickinessPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessPageDataProvider");
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const StickinessTableModalContentTabContent = (props) => {
    var _a;
    const [tableError, setTableError] = (0, react_1.useState)(undefined);
    const loaderRef = (0, react_1.useRef)();
    const currentComponentElementRef = (0, react_1.useRef)();
    // const stickinessContext = useStickinessContext();
    // const stickinessState: StickinessChartResultData | undefined = stickinessContext.data?.stickiness
    const stickinessContext = (0, StickinessPageDataProvider_1.useStickinessPageDataContext)();
    const stickinessState = (_a = stickinessContext.state.data) === null || _a === void 0 ? void 0 : _a.response;
    const destroyLoader = (0, react_1.useCallback)(() => {
        if (loaderRef.current && loaderRef.current.parentNode) {
            loaderRef.current.parentNode.removeChild(loaderRef.current);
        }
    }, [loaderRef]);
    const destroyTable = (0, react_1.useCallback)(() => {
        if (currentComponentElementRef.current) {
            currentComponentElementRef.current.innerHTML = "";
        }
    }, [currentComponentElementRef]);
    const drawTable = (0, react_1.useCallback)(() => {
        if (!stickinessState) {
            destroyLoader();
            return;
        }
        try {
            const container = currentComponentElementRef.current;
            const chartData = Array.from(stickinessState.chartData, v => Array.from(v));
            retention_table_1.RetentionTable.draw({
                type: "stickiness",
                repeatLevels: (0, RetentionTableService_1.getRepeatLevels)(chartData),
                initialDateMillis: stickinessState.intervalStartTimeSec * 1000,
                container: container,
                cohort: chartData,
                retentionPeriods: Array.from(stickinessState.periods),
                cohortName: "Cohort",
                stickinessType: props.lineType === LineTypeJSONModel_1.LineType.cumulative ? "cumulative" : "nonCumulative",
                cohortCheckEndDays: 0,
            });
            destroyLoader();
        }
        catch (e) {
            destroyLoader();
            destroyTable();
            setTableError(e);
        }
    }, [destroyLoader, destroyTable, currentComponentElementRef, JSON.stringify(stickinessState)]);
    (0, react_1.useEffect)(() => {
        window.setTimeout(function () {
            drawTable();
            document.querySelectorAll(".retention-table-bottom-table").forEach(value => value.classList.add("active"));
        }, 200);
    }, [drawTable]);
    return React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("span", { ref: loaderRef, style: { width: "100%", padding: "50px", display: "inline-block" } },
                React.createElement(PageLoaderComponent_1.default, null)),
            tableError && React.createElement(antd_1.Result, { status: "error", icon: React.createElement(React.Fragment, null), title: "Oops, something went wrong", subTitle: React.createElement(React.Fragment, null,
                    "Table cannot be loaded.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement("code", null, tableError.message)) }),
            React.createElement("div", { ref: currentComponentElementRef, className: "retentionTable" })));
};
exports.StickinessTableModalContentTabContent = StickinessTableModalContentTabContent;
